module.exports = __webpack_public_path__ + "img/couples-024.556f8e1c.jpg";